import styled from 'styled-components'
import { LinearProgress } from '@material-ui/core'
import { ILinearProgress } from './interfaces'

export const StyledLinearProgress = styled(LinearProgress)<ILinearProgress>`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) => height || 4}px;
  display: ${({ display }) => (display ? display : 'inline')};
`
